import request from '@/utils/request'

// 获取文章列表
export function getArticleList(data) {
  return request({
    method: 'post',
    path: 'article/lists',
    data
  })
}

// 保存文章
export function saveArticle(data) {
  return request({
    method: 'post',
    path: 'article/save',
    data
  })
}


// 删除文章
export function deleteArticle(data) {
  return request({
    method: 'post',
    path: 'article/delete',
    data
  })
}


// 获取文章列表（所有）
export function getAllArticleList(data) {
  return request({
    method: 'post',
    path: 'article/all',
    data
  })
}
